import axios from 'axios';

/** Território como a API o devolve. */
export interface BairroApi {
  id: string;
  tenant_id: string;
  slug: string;
  nome: string;
  uf: string;
  municipio: string;
  populacao: number;
  domicilios: number;
  eleitores: number;
  renda_media: number;
  votos: number;
  percentual: number | string;
  cobertura_cadastro: number;
  ubs: number;
  ubs_ideal: number;
  fila_dias: number;
  pavimentacao_pct: number;
  pontos_escuros: number;
  fila_creche: number;
  esgoto_pct: number;
  pracas: number;
  necessidade: number;
  // Metas por territorio. Existem no banco desde a migration inicial e a API
  // sempre as aceitou; faltava declarar aqui.
  meta_contatos: number;
  meta_liderancas: number;
  mapa_cor?: string;
  mapa_path?: string;
  mapa_label_x?: number;
  mapa_label_y?: number;
  // Agregados calculados no servidor a partir dos dados vivos do gabinete
  contatos_cadastrados: number;
  liderancas_ativas: number;
  solicitacoes_abertas: number;
  created_at: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';

const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const bairrosApi = {
  list: async (token: string) => {
    const res = await axios.get<BairroApi[]>(`${API_URL}/terr/bairros`, auth(token));
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<BairroApi>(`${API_URL}/terr/bairros/${id}`, auth(token));
    return res.data;
  },

  create: async (data: Partial<BairroApi>, token: string) => {
    const res = await axios.post<BairroApi>(`${API_URL}/terr/bairros`, data, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<BairroApi>, token: string) => {
    const res = await axios.put<BairroApi>(`${API_URL}/terr/bairros/${id}`, data, auth(token));
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/terr/bairros/${id}`, auth(token));
  },
};
